import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";

export default function ImplantologiaStrip() {
  return (
    <>
      <div className="h-9 md:h-10" aria-hidden="true" />
      <div
        className="fixed top-[72px] inset-x-0 z-40 bg-teal text-ivory shadow-soft"
        data-testid="implantologia-strip"
      >
        <div className="max-w-7xl mx-auto px-5 md:px-8 h-9 md:h-10 flex items-center justify-center gap-4 md:gap-6">
          <p className="flex items-center gap-2 text-[0.72rem] md:text-[0.82rem] font-semibold tracking-wide min-w-0">
            <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0" />
            <span className="truncate sm:hidden">Denti fissi in 6 ore</span>
            <span className="truncate hidden sm:inline">Denti fissi in 6 ore · Implantologia a carico immediato</span>
          </p>
          <a
            href="tel:01119667070"
            data-testid="strip-phone-link"
            className="hidden sm:inline-flex items-center gap-1.5 text-[0.72rem] md:text-[0.82rem] font-bold whitespace-nowrap hover:opacity-80 transition-opacity"
          >
            <Phone size={13} /> 011 19667070
          </a>
          <Link
            to="/servizi#implantologia"
            data-testid="strip-scopri-link"
            className="hidden md:inline-flex items-center gap-1 text-[0.72rem] md:text-[0.82rem] font-bold whitespace-nowrap underline underline-offset-4 decoration-gold hover:opacity-80 transition-opacity"
          >
            Scopri <ArrowRight size={13} />
          </Link>
        </div>
      </div>
    </>
  );
}
